"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableKeyboardSelectAllInstance = void 0;
const utilities_1 = require("./utilities");
function useTableKeyboardSelectAllInstance(hooks) {
    const OnKeyDown = (event, instance) => {
        const keyboardEvent = event;
        if (keyboardEvent.ctrlKey && keyboardEvent.key === "a") {
            if (utilities_1.IsRowSelectTableInstance(instance)) {
                instance.toggleAllRowsSelected(true);
            }
            else {
                console.error("useTableKeyboardSelectAll plugin requires the useRowSelect plugin to be enabled");
            }
        }
    };
    hooks.getTableProps.push((tableProps, { instance }) => {
        return Object.assign(Object.assign({}, tableProps), { onKeyDown: (event) => OnKeyDown(event, instance), tabIndex: "0" });
    });
}
exports.useTableKeyboardSelectAllInstance = useTableKeyboardSelectAllInstance;
//# sourceMappingURL=table-keyboard-select-all.js.map